import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";
import { bookingMetadataTypes } from "@shared/constants/bookingMetadataTypes";
import { httpHeaders } from "@shared/constants/httpHeaders";

import { type IBookingMetadata } from "@types";

export const BOOKING_METADATA_MAGIC_LINK = "bookingMetadataMagicLink";
export const bookingMetadataMagicLinkApi = createApi({
  reducerPath: BOOKING_METADATA_MAGIC_LINK,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    postBookingMetadataMagicLink: builder.mutation<void, { token: string; metadata: IBookingMetadata["data"] }>({
      query: ({ token, metadata }) => ({
        url: "/booking-metadata-magic-link",
        method: "POST",
        body: { type: bookingMetadataTypes.inputMeetingData, data: metadata },
        headers: { [httpHeaders.magicToken]: token },
      }),
    }),
  }),
});

export const { usePostBookingMetadataMagicLinkMutation } = bookingMetadataMagicLinkApi;
